module.exports = __webpack_public_path__ + "static/img/11.cbeb455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/11.jpg
// module id = IZNT
// module chunks = 1